import React from 'react';
import { SurveyPieCard, SurveyPieCategory } from './SurveyPieCard';
import { SurveyResponse } from '../../../shared/constants';
import {
  customError,
  customSuccess,
  lightTeal,
  orange,
} from '../../../mainTheme';

// `type` (not `interface`) so it satisfies SurveyPieCard's Record<string, number>.
type PatientSurveyData = {
  veryHappy: number;
  somewhatHappy: number;
  somewhatUnhappy: number;
  veryUnhappy: number;
};

interface PatientSurveyCardProps {
  isSelected?: boolean;
  onClick?: () => void;
  data: PatientSurveyData;
}

// Hub overall experience (CSAT) buckets, lowest → highest.
export const SURVEY_CATEGORIES: SurveyPieCategory[] = [
  { name: SurveyResponse.VeryUnhappy, key: 'veryUnhappy', color: customError },
  {
    name: SurveyResponse.SomewhatUnhappy,
    key: 'somewhatUnhappy',
    color: orange,
  },
  {
    name: SurveyResponse.SomewhatHappy,
    key: 'somewhatHappy',
    color: lightTeal,
  },
  { name: SurveyResponse.VeryHappy, key: 'veryHappy', color: customSuccess },
];

export const PatientSurveyCard: React.FC<PatientSurveyCardProps> = ({
  isSelected,
  onClick,
  data,
}) => (
  <SurveyPieCard
    title="Patient survey"
    categories={SURVEY_CATEGORIES}
    data={data}
    isSelected={isSelected}
    onClick={onClick}
    testId="patient-survey-card"
  />
);
